import { Textarea } from '@web/components/atoms/Textarea'
import { Field } from '@web/components/atoms/Field'
import { CustomFieldComponentProps } from '../CustomFieldComponent'

const CustomTextArea = ({
  isRequired,
  name,
  label,
  placeholder,
  fieldDescription,
  onChange,
  value,
  id,
  hideLabel,
}: CustomFieldComponentProps) => {
  return (
    <Field
      label={hideLabel ? '' : label}
      required={isRequired}
      htmlFor={`custom-field-${name}`}
      helperText={fieldDescription}
    >
      <Textarea
        id={`custom-field-${name}`}
        name={name}
        required={isRequired}
        aria-required={isRequired || undefined}
        onChange={(e) => {
          onChange?.({
            target: {
              name: id,
              value: e.target.value,
            },
          } as React.ChangeEvent<HTMLTextAreaElement>)
        }}
        value={typeof value === 'string' ? value : ''}
        placeholder={placeholder ?? ''}
        bgColor="ge.white"
        color="ge.text.primary"
      />
    </Field>
  )
}

export default CustomTextArea
